import { CheckBoxProps } from '@toggle/design-system';
import React from 'react';

import * as S from './RowSelectionCheckbox.styles';

interface RowSelectionCheckboxProps extends Omit<CheckBoxProps, 'label'> {}

export const RowSelectionCheckbox = (props: RowSelectionCheckboxProps) => {
  return <S.StyledCheckBox {...props} label="" />;
};
